module.exports = __webpack_public_path__ + "media/images/pages/fcr/doctor-1-6fdd49c280b892f60a4f5e3d445aa64c.png";